import { render, staticRenderFns } from "./Wjxh.vue?vue&type=template&id=453fe6f4&scoped=true&"
import script from "./Wjxh.vue?vue&type=script&lang=js&"
export * from "./Wjxh.vue?vue&type=script&lang=js&"
import style0 from "./Wjxh.vue?vue&type=style&index=0&id=453fe6f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453fe6f4",
  null
  
)

export default component.exports